import { createContext } from 'react'
import { User } from '../data/types/User'
import { AxiosError } from 'axios'

export const AppContext = createContext<{
  toggleColorMode: () => void
  user: User | undefined
  error: AxiosError | Error | null
}>({
  toggleColorMode: () => {},
  user: undefined,
  error: null,
})

export default AppContext
